export var HistogramValue;
(function (HistogramValue) {
    HistogramValue["Hour"] = "hour";
    HistogramValue["Day"] = "day";
    HistogramValue["Week"] = "week";
    HistogramValue["Month"] = "month";
})(HistogramValue || (HistogramValue = {}));
export var NRTHistogramValue;
(function (NRTHistogramValue) {
    NRTHistogramValue["OneMin"] = "1_min";
    NRTHistogramValue["TwoMin"] = "2_min";
    NRTHistogramValue["FiveMin"] = "5_min";
})(NRTHistogramValue || (NRTHistogramValue = {}));
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;
export const HistogramValueBounds = {
    [HistogramValue.Hour]: {
        maxInclusive: 7 * ONE_DAY_IN_MS,
    },
    [HistogramValue.Day]: {},
    [HistogramValue.Week]: {
        minExclusive: ONE_DAY_IN_MS,
    },
    [HistogramValue.Month]: {
        minExclusive: 7 * ONE_DAY_IN_MS,
    },
};
//# sourceMappingURL=histogram-value.js.map